/* SPOOKY CART — predictive search */
(function () {
  'use strict';
  const S = window.Spooky || {};

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-predictive-search]').forEach(setup);
  });

  function setup(wrapper) {
    const input = wrapper.querySelector('input[type="search"]');
    const results = wrapper.querySelector('[data-predictive-results]');
    if (!input || !results) return;

    let controller = null;
    let timer = null;
    let activeIndex = -1;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', results.id);

    const close = () => {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    };
    const open = () => {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const render = (html) => {
      results.innerHTML = html;
      open();
      activeIndex = -1;
    };

    const search = async (term) => {
      if (controller) controller.abort();
      controller = new AbortController();
      results.innerHTML = '<div class="predictive-search__empty">' + (S.strings?.loadingText || 'Searching...') + '</div>';
      open();
      try {
        const url =
          S.routes.predictiveSearch +
          '?q=' + encodeURIComponent(term) +
          '&resources[type]=product,collection,page' +
          '&resources[limit]=6' +
          '&section_id=predictive-search';
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error('search failed');
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const inner = doc.querySelector('[data-predictive-inner]');
        render(inner ? inner.innerHTML : '');
      } catch (err) {
        if (err.name === 'AbortError') return;
        render('<div class="predictive-search__empty">' + (S.strings?.error || 'Search unavailable') + '</div>');
      }
    };

    input.addEventListener('input', () => {
      const term = input.value.trim();
      clearTimeout(timer);
      if (term.length < 2) { close(); return; }
      timer = setTimeout(() => search(term), 220);
    });

    input.addEventListener('keydown', (e) => {
      const items = Array.from(results.querySelectorAll('.predictive-search__item'));
      if (e.key === 'Escape') { close(); input.blur(); return; }
      if (!items.length || results.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex += e.key === 'ArrowDown' ? 1 : -1;
        if (activeIndex < 0) activeIndex = items.length - 1;
        if (activeIndex >= items.length) activeIndex = 0;
        items.forEach((it, i) => it.classList.toggle('is-active', i === activeIndex));
        items[activeIndex].focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!wrapper.contains(e.target)) close();
    });
    wrapper.addEventListener('focusout', (e) => {
      if (!wrapper.contains(e.relatedTarget)) close();
    });
  }
})();
